import { NextPage } from 'next';

import { Error } from '@/core/components/Error';

const ErrorPage: NextPage = () => (
  <Error statusCode={404} />
);

export default ErrorPage;
